import { render } from "./App.vue?vue&type=template&id=37fd2553"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37fd2553&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__